import React, { useCallback, useEffect, useRef, useState } from 'react'
import BaseHome from '../Home/BaseHome'
import LevelIcon from "../../assets/images/level.png"
import Newsimg from "../../assets/images/gamenews.jpeg"
import { getFeaturedVideo } from '../../api/worldOfEsports.api';
import ListLoader from '../Common/ListLoader';
import { t } from 'i18next';
import { useNavigate } from "react-router-dom";

const PopularVideos = () => {
  const navigate = useNavigate();
  const [featuredVideoList, setFeaturedVideoList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(12);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (currentPage <= totalPages)
      loadMore()
  }, [currentPage])

  const loadMore = async () => {
    setLoading(true)
    fetchPopularVideoList()
  }

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchPopularVideoList = async () => {
    
    try {
      const data = ({
        "pagination": {
          "pageNo": currentPage,
          "recordPerPage": recordPerPage,
          "sortBy": "order",
          "sortDirection": "desc"
        },
        "search": {
          "isLive": false
        }
      });
      const res= await getFeaturedVideo(data)
      setLoading(false)
      if (res?.success && res?.data) {
        setFeaturedVideoList([...featuredVideoList, ...res?.data])
        setTotalPages(res?.totalPages);
      }
      else {
        setFeaturedVideoList([]);
      }
    } catch (error) {
      setFeaturedVideoList([]);
    }
  };

  const videoUrls = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);

    if (match?.length > 0) {
      let videoId = match && match[2].length === 11 ? match[2] : null;

      return "//www.youtube.com/embed/" + videoId;
    }
    return ""
  };

  const openPopularVideo = (id, name, url) => {
    navigate("/world-of-eports/popularvideo", {
      state: { id, name, url },
    })
  }

  return (
    <BaseHome isFooter={false} title={t("woe.videos")} MaxFullPageScroll={false}>
      {featuredVideoList?.length > 0 ?
        <div className='world-of-esports-main-wrap'>
          <div className='world-of-esports-inner-wrap pb-4'>
          <div className='world-of-esports-popularvideobox mt-4' style={{gap:"11px",flexWrap:"wrap"}}>
            {featuredVideoList?.length > 0 && featuredVideoList.map((data, index) => (
              data?.url && videoUrls(data?.url) &&
              
                <div className='world-of-esports-popularvideobox-innerwrap' style={{width:"100px"}}  key={index} ref={featuredVideoList?.length === index + 1 ? lastPostElementRef : null}>

                  <div className='world-of-esports-popularvideo-inner-box'>
                    {/* <iframe
                      width="100%"
                      height="95px"
                      src={videoUrls(data?.url)}
                      title={data?.name}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe> */}
                    <div style={{ position: "relative", width: "100%", height: "95px" }}>
                      <iframe
                        width="100%"
                        height="95px"
                        src={videoUrls(data?.url)}
                        title={data?.name}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          background: "transparent",
                        }}
                        onClick={(e) => {
                          e.stopPropagation()
                          openPopularVideo(data?._id, data?.name, data?.url)
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className='world-of-esports-inner-video-title'>
                    {data?.name?.length > 20 ?
                      <marquee>{data?.name}</marquee>
                      :
                      data?.name
                    }
                  </div>
                
              </div>
            ))}
          </div></div>
        </div>
        :
        !loading && 
        <div className='w-100 d-flex justify-content-center'><span className="text-center">No data found</span></div>
      }
       {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>}
    </BaseHome>
  )
}

export default PopularVideos